import { LINK } from 'global/constants';
import {
  StimulusLibrary,
  StimulusLibraryCreate,
} from '../shared/stimulus-library';
import { EditProps } from './link.constants';
import LinkEditDrawer from './link-edit-preview-drawer';

const LinkSettings = (props: EditProps) => {
  return props.properties.stimulusId ? (
    <LinkEditDrawer {...props} />
  ) : (
    <StimulusLibrary
      stimulusType={LINK}
      componentId={props.id}
      title="Link"
      canGoBack={false}
      headerActionButton={
        <StimulusLibraryCreate
          sectionId={props.sectionId}
          componentId={props.id}
          contentId={props.lessonId}
          type={LINK}
        />
      }
      {...props}
    />
  );
};

export default LinkSettings;
